<header class="header">
  <div class="title">
    <kin-icon name="workout_stroke" [color]="colorService.textColor() || 'white'" />
    <h3>{{ 'workout_uploader.title' | translate }}</h3>
  </div>
  <p>{{ 'workout_uploader.import_hint' | translate }}</p>
</header>

@if (importedFile(); as file) {
  <div class="imported-file">
    <header>
      <kin-icon name="workout_stroke" [color]="colorService.textColor() || 'white'" />
      <h5>{{ file.name }}</h5>
      <p>{{ 'workout_uploader.imported' | translate }}</p>
    </header>
    <button type="button" class="remove-file-btn" (click)="onRemoveFile()">
      <kin-icon name="trash" color="#EA302D" />
      <p>{{ 'common.delete' | translate | titlecase }}</p>
    </button>
  </div>
} @else {
  <label for="workout-file" (drop)="onDrop($event)" (dragover)="$event.preventDefault()">
    <header>
      <kin-icon name="upload" color="#428FF3" />
      <h5>{{ 'workout_uploader.upload_title' | translate }}</h5>
      <p>{{ 'workout_uploader.upload_hint' | translate }}</p>
    </header>
    <footer>
      <span class="files-type-required-label">{{ 'common.file.format' | translate }}</span>
      <span class="files-type-required-list">.ZWO</span>
    </footer>
  </label>
}

<input type="file" id="workout-file" accept=".zwo" (change)="onSelectFile($event)" />
